import { Suspense, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Redirect } from 'react-router-dom';

import * as styles from './styles';

import { Location, UserRole } from '@cobliteam/common-types';

import { webDataNotAsked } from '@cobliteam/api-lib';

import {
  type AppState,
  history,
  loginResetState,
  selectLocationPathname,
} from '@cobliteam/store';

import { useTitle } from '@cobliteam/hooks';

import { CobliLogo, Loading } from '@cobliteam/base-components';

import { Button } from '@cobliteam/ui/components';

import ArrowBackRoundedIcon from '@material-ui/icons/ArrowBackRounded';

const AuthLayout = ({ children }: any) => {
  useTitle('Login');
  const dispatch = useDispatch();
  const session = useSelector((state: AppState) => state.login.session);
  const pathname = useSelector((state: AppState) =>
    selectLocationPathname(state)
  );
  const isHome = useMemo(() => pathname === Location.LOGIN, [pathname]);

  if (session) {
    return session.user.role !== UserRole.MAP_VIEW ? (
      <Redirect to={Location.HOME} />
    ) : (
      <Redirect to={Location.MONITORING} />
    );
  }

  const handleGoBack = () => {
    if (pathname === Location.TOKEN_VALIDATION) {
      dispatch(
        loginResetState({
          forgetPasswordWebData: webDataNotAsked(),
          validateTokenWebData: webDataNotAsked(),
          token: '',
        })
      );
    }

    history.goBack();
  };

  return (
    <div className={styles.login}>
      <CobliLogo className={styles.logo} />

      <div className={styles.previousStep}>
        {isHome ? null : (
          <Button
            variant='text'
            startIcon={<ArrowBackRoundedIcon />}
            onClick={handleGoBack}
          >
            Voltar
          </Button>
        )}
      </div>

      <Suspense fallback={<Loading />}>{children}</Suspense>
    </div>
  );
};

export default AuthLayout;
